import { Component } from '@angular/core';
import { KanaalSelectorBase } from '../kanaal-selector/KanaalSelectorBase';
import { AnalogIn } from '../../props/PropTypes';

@Component({
  selector: 'detailed-kanaal-selector',
  templateUrl: './detailed-selector.component.html',
  styleUrl: './detailed-selector.component.scss'
})
export class DetailedSelectorComponent extends KanaalSelectorBase {


  public rowSize() {
    return 16;
  }

  public startOffset() {
    if (AnalogIn.equals(this.kanaalType())) {
      return 1;
    }
    return 0;
  }

  public onDetailClick(x: number, y: number) {
    let asgn = this.kanaalMap()[x][y];

    let kanaal = this.getKanaalForCell(x, y);
    if (this.isValidSelection(kanaal)) {
      this.selection.set({
        kanaal: {
          start: kanaal,
          ioType: this.kanaalType()!,
          range: this.range()

        },
        assignement: asgn
      });
      this.onKanaalSelected.emit(this.selection());
    }
  }

}
